import { HHTypography } from '@hinge-health/react-component-library';
import { Verdict } from '../utils/verdict.utils';

export const VERDICT_LINE_TEST_ID = 'pdg-verdict-line';
export const VERDICT_LOADING_TEXT = 'Checking providers…';

interface VerdictLineProps {
  verdict: Verdict;
  isLoading?: boolean;
}

/** One sentence: the headline, then "Needs a look:" and only the clauses that apply. */
export const verdictSentence = ({ headline, clauses }: Verdict): string =>
  clauses.length === 0
    ? headline
    : `${headline} Needs a look: ${clauses.join(', ')}.`;

export const VerdictLine = ({
  verdict,
  isLoading = false,
}: VerdictLineProps): JSX.Element => (
  <HHTypography
    hhVariant="variant-bypass"
    variant="body1"
    color="text.secondary"
    data-testid={VERDICT_LINE_TEST_ID}
  >
    {isLoading ? VERDICT_LOADING_TEXT : verdictSentence(verdict)}
  </HHTypography>
);
